import AppIcons from "src/components/AppIcons";
import styled from "styled-components";

export const StyledButton = styled.button`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    background-color: var(--card-background); 
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    border: none;
    border-radius: 8px;
    margin: 0.75rem 0.5rem;
    padding: 1rem;
    transition: 200ms ease;

    >h3{
        margin-left: 0;
    }

    &:hover{
        filter: brightness(0.9);
    }
`;

export const StyledAppIcons = styled(AppIcons)`
    path:first-child{
        fill: var(--card-background);
        stroke: var(--card-background);
    }
    path:last-child{
        fill: inherit;
    }
`;

export default StyledButton;

